// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38xlt","notes":"Notes_notes__LrRyY"};